import type { SVGProps } from "react";

export const SkippedStatusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M3 9C3.175 7.5125 3.825 6.26562 4.95 5.25938C6.075 4.25313 7.4 3.75 8.925 3.75C9.8375 3.75 10.6813 3.93438 11.4563 4.30313C12.2313 4.67188 12.8938 5.175 13.4438 5.8125V3.75H14.9438V9H9.69375V7.5H12.8438C12.4438 6.825 11.9031 6.28125 11.2219 5.86875C10.5406 5.45625 9.78125 5.25 8.94375 5.25C7.84375 5.25 6.875 5.60625 6.0375 6.31875C5.2 7.03125 4.69375 7.925 4.51875 9H3Z"
      fill="white"
    />
    <path
      d="M8.9436 14.25C8.3186 14.25 7.78735 14.0312 7.34985 13.5938C6.91235 13.1562 6.6936 12.625 6.6936 12C6.6936 11.375 6.91235 10.8438 7.34985 10.4062C7.78735 9.96875 8.3186 9.75 8.9436 9.75C9.5686 9.75 10.0999 9.96875 10.5374 10.4062C10.9749 10.8438 11.1936 11.375 11.1936 12C11.1936 12.625 10.9749 13.1562 10.5374 13.5938C10.0999 14.0312 9.5686 14.25 8.9436 14.25Z"
      fill="#FDA4AF"
    />
  </svg>
);
